<template>
  <div>
    <analysis-header :totalAmount="totalAmount" ref="analysisHeader" :title="'En Çok Satan '+ topCount +' Ürün'" @update-range="updateRange"></analysis-header>
    
    <b-row class="match-height" v-if="dataList.length>0 && !accessMessage">
        <!-- Sipariş Tutarları Grafiği -->
        <b-col md="12">
            <chartjs-top-product ref="topCharts" :chartData="chartDataHorizontal" @select-row="selectRow" :loadChart="loadChart" v-if="!accessMessage"/>
        </b-col>
    </b-row>
    <b-row v-else-if="accessMessage">
      <b-col class="text-danger">
        {{ accessMessage }}
      </b-col>
    </b-row>
    <b-card-title class="text-danger mt-2" v-else>Seçilen tarihler arasında kayıt bulunamadı</b-card-title>
    
    <!-- Row Detail -->
    <b-modal 
    class="position-fixed row-detail-popup"
    :visible="detailPopup"
    v-if="detailPopup"
    size="xl"
    @change="(val) => detailPopup=val"
    :title="selectedProduct.name"
    cancel-button
    hide-footer
    ok-title="Kapat"
    >
      <b-card>
        <b-row
          v-if="selectedProduct!=null">
            <b-col md="4">
              <b-card
                class="ecommerce-card"
                no-body
              >


                <!-- Product Details: Card Body -->
                <b-card-body class="d-flex flex-column align-items-center">
                  <!-- Product Image -->
                  <div class="item-img">
                    <b-link>
                      <b-img
                        class="w-100"
                        :src="selectedProduct.image || $store.state.appConfig.notImageUrl"
                        :alt="`${selectedProduct.name}-${selectedProduct.id}`"
                      />
                    </b-link>
                  </div>
                  <div class="item-name my-1">
                    <b-link class="text-body">
                      {{ selectedProduct.name }} 
                    </b-link>
                  </div>
                  <span class="item-company my-1">Marka <b-link class="company-name">{{ selectedProduct.brand }}</b-link></span>              
                  <div class="item-wrapper d-flex justify-content-between">
                    <h6 class="item-price">
                      Güncel fiyat :  {{ selectedProduct.base_price }}  {{ selectedProduct.currency }} 
                    </h6>
                  </div>
                </b-card-body>
              </b-card>

            </b-col>

            <b-col md="8">
              <b-card
                no-body
                class="mb-0"
              >                       
                  <b-card-header class="w-100">
                    <div>
                      <b-card-title>{{ priceFormat(selectedProduct.orders_total_amount) }} - {{ selectedProduct.total_quantity }} Adet</b-card-title>
                    </div>
                  </b-card-header>
                  <b-table-lite
                      responsive
                      :items="selectedProduct.groupedOrders"
                      :fields="[
                        { key: 'influencer', label: 'Fenomen' },
                        { key: 'total_quantity', label: 'Toplam Ürün' },
                        { key: 'campaigns', label: 'Kampanyalar' }
                      ]"
                      row-details
                  >
                      <template #cell(influencer)="data">
                          <influencer-link-btn 
                              :id="data.item.influencer.id" 
                              :name="data.item.influencer.username" 
                          />
                      </template>

                      <template #cell(total_quantity)="data">
                          <b>{{ data.item.total_quantity }} Adet</b>
                      </template>

                      <template #cell(campaigns)="data">
                          <div v-if="data.item.campaigns.length === 1" class="d-flex align-items-center">
                              <campaign-link-btn 
                                  :id="data.item.campaigns[0].link.id" 
                                  :name="data.item.campaigns[0].link.campaign_name"
                                  :route="getLinkName(data.item.campaigns[0].link)"
                              />
                              <span class="ml-2 text-muted small">
                                  ({{ data.item.campaigns[0].total_quantity }} Adet)
                              </span>
                          </div>

                          <div v-else class="d-flex align-items-center cursor-pointer" @click="data.toggleDetails">
                              <span class="mr-2">
                                  {{ data.item.campaigns.length }} Kampanya
                                  ({{ data.item.total_quantity }} Adet)
                              </span>
                              <div>
                                <FeatherIcon icon="ChevronUpIcon" v-if="data.detailsShowing"></FeatherIcon>
                                <FeatherIcon icon="ChevronDownIcon" v-else></FeatherIcon>
                            </div>
                              
                          </div>
                      </template>

                      <template #row-details="data">
                          <b-table
                              responsive
                              :items="data.item.campaigns"
                              :fields="[
                                  { key: 'campaign_name', label: 'Kampanya Adı' },
                                  { key: 'total_quantity', label: 'Toplam Ürün' },
                              ]"
                              :columnheader="false"
                          >
                              <template #cell(campaign_name)="campaign">
                                  <campaign-link-btn 
                                      :id="campaign.item.link.id" 
                                    :name="campaign.item.link.campaign_name"
                                    :route="getLinkName(campaign.item.link)"
                                  />
                                  
                              </template>

                              <template #cell(total_quantity)="campaign">
                                  <b>{{ campaign.item.total_quantity }} Adet</b>
                              </template>
                          </b-table>
                      </template>
                  </b-table-lite>

              </b-card>
              <product-campaign-charts :chartData="chartProductCampaign" :loadChart="loadChartProduct" />
              
            </b-col>
          </b-row>
      </b-card>
    </b-modal>
    <!-- Row Detail End -->
    
  </div>
</template>
  
  <script>
  import AnalysisHeader from './AnalysisHeader.vue'
  import { BRow, BCol, BCard,BCardHeader, BButton, BTableLite, BCardTitle, BSpinner, BLink, BImg, BCardBody, BButtonGroup, BTable, BCardSubTitle, BModal } from 'bootstrap-vue'
  import vSelect from 'vue-select';
  import CampaignLinkBtn from '@/components/link/CampaignLinkBtn.vue'
  import ChartjsTopProduct from './TopProductCharts.vue'
  import ProductCampaignCharts from './ProductCampaignCharts.vue'
  import InfluencerLinkBtn from '@/components/link/InfluencerLinkBtn.vue';
  
  export default {
    components: {
      BRow,
      BCol,
      BCard,
      BCardBody,
      BCardHeader,
      BCardTitle,
      BCardSubTitle,
      BButton,
      BTable,
      BTableLite,
      BSpinner,
      BLink,
      BImg,
      BButtonGroup,
      BModal,

      AnalysisHeader,
      CampaignLinkBtn,
      InfluencerLinkBtn,
      ChartjsTopProduct,
      ProductCampaignCharts,
      vSelect
    },
    data() {
      return {  
        loadChart:false,
        loadChartProduct:false,
        detailPopup:false,
        dataList:[],
        selectedProduct:null,
        chartData: {
          labels: [],
          datasets: [
            {
              data: [],
              backgroundColor:  '#0c8f0c',
              borderColor: 'transparent',
              barThickness: 15
            },
          ],
        },
        chartDataHorizontal:{},
        chartProductCampaign:{},
        sortedDataList:[],
        topCount:10,
        accessMessage: null,
      }
    },
    created () {
      // İlk yüklemede rangeDate bu ay bilgilerini al
      const today = new Date();
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const rangeDate = [this.changeFormat(firstDayOfMonth), this.changeFormat(today)];
      this.getData(rangeDate[0], rangeDate[1], this.topCount);
    },
    methods: {
       getLinkName(item) {
        let route = {
          name: '',
          params: {
            id: item.id
          }
        };

        if (item.type == 0) {
          if (item.links && item.links.length > 0) {
            route.name = "campaign-group-detail";
            route.params.id = item.group_id;
          } else {
            route.name = "campaign-detail";
          }
        } else if (item.type == 1) {
          route.name = "story-detail";
        } else if (item.type == 2) {
          route.name = "sms-detail";
        } else if (item.type == 4) {
          route.name = "whatsapp-detail";
        } else if (item.type == 3) {
          route.name = "bio-detail";
          route.params.platform_id = item.platform.id;
        }

        return route;
      },
        updateRange(range){
          // Tarihleri API'ye gönder
          this.getData(range[0], range[1],this.topCount);
        },
        getData(startDate = null, endDate = null, top_list = null) {
            this.$http
                .get('/analysis/product', {
                    params: { start_date: startDate, end_date: endDate, top_list, source: 'homepage' },
                })
                .then((response) => {
                  if(response.data.success){
                    this.dataList = response.data.data;
                    console.log(this.dataList)
                    this.updateChartData();
                  }else{
                    this.accessMessage = response.data.message;
                    this.loadChart = true;
                  }
                })
                .catch((error) => {
                    console.error('Veri alımı sırasında bir hata oluştu:', error);
                });
        },
        selectRow(index) {
            this.detailPopup = true;
            this.selectedProduct = this.sortedDataList[index];
            const campaigns = this.selectedProduct.campaigns || [];

            // groupedOrders güncelle (eğer hala kullanıyorsanız)
            this.selectedProduct.groupedOrders = this.groupCampaigns(campaigns);

            // Satış adedine göre büyükten küçüğe sıralama
            const sortedCampaigns = [...campaigns].sort((a, b) => (b.quantity ?? 0) - (a.quantity ?? 0));

            // Chart için kampanya bazlı etiket ve veri hazırlama
            const chartLabels = sortedCampaigns.map(c => c.campaign_name ?? c.link?.campaign_name ?? 'Bilinmeyen');
            const chartData = sortedCampaigns.map(c => c.quantity ?? 0);    

            // chartData'dan kopyalama yaparak tüm ayarları al
            this.chartProductCampaign = JSON.parse(JSON.stringify(this.chartData));

            // Sadece labels ve data'yı değiştir
            this.chartProductCampaign.labels = chartLabels;
            this.chartProductCampaign.datasets[0].data = chartData;
            this.chartProductCampaign.datasets[0].label = 'Satış Adedi';

            // Grafik yüklemesini tetikle
            this.loadChartProduct = false;
            setTimeout(() => {
                this.loadChartProduct = true;
            }, 500);

        },


        groupCampaigns(campaigns) {
            const influencerGroups = {};

            campaigns.forEach(campaign => {
                const inf = campaign.influencer;
                const infId = inf.id;
                const linkId = campaign.link_id;

                if (!influencerGroups[infId]) {
                    influencerGroups[infId] = {
                        influencer: inf,
                        total_quantity: 0,
                        total_amount: 0,
                        campaigns: {}
                    };
                }

                if (!influencerGroups[infId].campaigns[linkId]) {
                    influencerGroups[infId].campaigns[linkId] = {
                        link: {
                            id: campaign.link_id,
                            campaign_name: campaign.campaign_name,
                            type: campaign.type,
                            platform: campaign.platform,
                        },
                        total_quantity: 0,
                        total_amount: 0
                    };
                }

                // Kampanya bazında ve influencer bazında toplama
                influencerGroups[infId].campaigns[linkId].total_quantity += campaign.quantity;
                influencerGroups[infId].campaigns[linkId].total_amount += campaign.total_amount;

                influencerGroups[infId].total_quantity += campaign.quantity;
                influencerGroups[infId].total_amount += campaign.total_amount;
            });

            // Dönüştürülmüş ve sıralanmış liste
            return Object.values(influencerGroups)
                .sort((a, b) => b.total_quantity - a.total_quantity)
                .map(influencer => ({
                    ...influencer,
                    campaigns: Object.values(influencer.campaigns)
                        .sort((a, b) => b.total_quantity - a.total_quantity)
                }));
        },
        updateChartData() {
            this.loadChart = false;

            this.sortedDataList = [...this.dataList].sort((a, b) => {
                return b.total_quantity - a.total_quantity;
            });

            const labels = this.sortedDataList.map((item) => item.name);
            const dataAmount = this.sortedDataList.map((item) => item.total_quantity);

            this.chartDataHorizontal = JSON.parse(JSON.stringify(this.chartData));
            this.chartDataHorizontal.labels = [...labels];
            this.chartDataHorizontal.datasets[0].data = [...dataAmount];
            setTimeout(() => {
                this.loadChart = true;
            }, 500);
        }

    },
    computed: {
      totalAmount() {
          const totalAmount = this.dataList.reduce((grandTotal, product) => {
              const amount = product.orders_total_amount ?? 0;
              const numericAmount = typeof amount === 'string'
                  ? parseFloat(amount.replace(/\./g, '').replace(',', '.')) || 0
                  : amount;

              return grandTotal + numericAmount;
          }, 0);

          return totalAmount ?? 0;
      },
      tableFields() {
        // `isFenomen` durumuna göre `fields` belirleniyor
        const fields = [
          { key: "link", label: "Paylaşım" },
          { key: "quantity", label: "Adet" },
          { key: "amount", label: "Birim Fiyat" },
          { key: "total_amount", label: "Toplam Ürün Fiyat" },
        ];
        if (!this.isFenomen) {
          fields.unshift({ key: "influencer", label: "Fenomen" }); // En başa ekle
        }
        return fields;
      },
    },
    watch: {
    },
  }
  </script>
  
  <style>
  .row-detail-popup-light{
    z-index: 9999;
  }
  .row-detail-popup{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99999;
    max-height: 90vh;
    overflow: auto
  }

  </style>
  <style lang="scss">
  @import "~@core/scss/base/pages/app-ecommerce.scss";
  </style>
  